import { z } from 'zod';
import { permissionSchema } from '#src/auth/permissions.contract.js';
export const PERMISSION_TITLE_MAX = 100;
export const PERMISSION_DESCRIPTION_MAX = 500;
/**
 * Uma permissão como a tela a mostra: o texto em vigor (o do administrador,
 * se houver, ou o do código) e o padrão, para restaurar.
 */
export const permissionEntrySchema = z.strictObject({
    key: permissionSchema,
    title: z.string(),
    description: z.string(),
    defaultTitle: z.string(),
    defaultDescription: z.string(),
    /** O administrador reescreveu o título ou a descrição. */
    customized: z.boolean(),
    /** Quem mudou o texto por último, e quando; nulos sem mudança. */
    customizedBy: z.string().nullable(),
    customizedAt: z.iso.datetime({ offset: true }).nullable(),
    /** O que ela exige, direto (as exigidas podem exigir outras). */
    requires: z.array(permissionSchema),
});
export const permissionListSchema = z.strictObject({
    items: z.array(permissionEntrySchema),
});
/**
 * Reescreve o texto de uma permissão. `null` volta ao do código. A chave e o
 * que ela libera não mudam: são do código.
 */
export const updatePermissionRequestSchema = z.strictObject({
    title: z.string().trim().min(1).max(PERMISSION_TITLE_MAX).nullable(),
    description: z
        .string()
        .trim()
        .min(1)
        .max(PERMISSION_DESCRIPTION_MAX)
        .nullable(),
});
//# sourceMappingURL=permission.contract.js.map